{
  "djsgy/": "{itemCount, plural, one {la till tagg} other {la till taggar}}",
  "zUIE28": "Hög",
  "6YJ9kc": "skapad",
  "0pto9m": "Veckorutiner",
  "5/IG+A": "ändrade deadline till \"{newDueDate}\"",
  "pZMRGW": "Akut",
  "EusdGt": "{itemCount, plural, one {tilldelade roll} other {tilldelade roller}}",
  "W1oW5d": "Produkter",
  "xaYr2d": "Taggar",
  "b+vXUf": "{itemCount, plural, one {tog bort roll} other {tog bort roller}}",
  "NFEWMC": "Avvikelse",
  "QJKEn6": "Prio",
  "3n9TPc": "Alla Avdelningar",
  "JAkKPp": "Kontakt",
  "AAByEP": "Det finns inget att visa här just nu.",
  "AOS79r": "{count} taggar",
  "F0Def9": "{count} produkter",
  "g2XiDM": "Avvikelse",
  "o8s2eZ": "tilldelade avdelningar",
  "O1wWXl": "tog bort avdelningar",
  "wuJzoK": "tilldelade",
  "JakbE6": "Slutar {value}",
  "nWlf5r": "ändrade titel: \"{newTitle}\"",
  "4/DQ6s": "{itemCount, plural, one {tog bort tag} other {tog bort taggar}}",
  "SRj8th": "tog bort taggar",
  "mFJfBr": "{count} taggar",
  "xu5sb3": "Normal",
  "We68tg": "V. {value}",
  "22f6MY": "Prioritet",
  "aI8RqJ": "Andra ({numberOfOthers})",
  "HFiDxi": "Dagliga Rutiner",
  "Zhbm36": "Inget återkoppling behövs",
  "BcqKUf": "Alla Avdelningar",
  "xABthc": "Tilldelade mig",
  "1GJfGN": "Deadline",
  "fnbGxf": "{itemCount, plural, one {tog bort tilldelning} other {tog bort tilldelningar}}",
  "R+G59o": "Ej återkopplad",
  "liO+AM": "Det finns inget att visa här just nu.",
  "/5v5P1": "Det finns inget att visa här just nu.",
  "yUF/4k": "la till taggar",
  "98m5kb": "Nu",
  "FPRwdN": "Alla avdelningar",
  "wpjtYH": "Snart",
  "AcxqTO": "{value, plural, one {# händelse} other {# händelser}}",
  "WvuPXi": "Låg",
  "dFhCRb": "och",
  "9Vxs2U": "markerade som ej slutförd",
  "ptY4eS": "Månadsrutiner",
  "d6t9lP": "flyttade till lista: \"{newCategory}\"",
  "FQ2auD": "{itemCount, plural, one {tilldelade avdelning} other {tilldelade avdelningar}}",
  "GsO09W": "Avdelningar",
  "lkVfWe": "{itemCount, plural, one {tog bort avdelning} other {tog bort avdelningar}}",
  "GwqxI3": "Tilldela",
  "qcak1o": "Total",
  "+7+2/G": "ändrade prio till {newPriority}",
  "ePU4cQ": "Kommer synas på samtliga enheter och visualiseras extra kraftfullt både på Storecast och i appen.",
  "odVGV2": "Taggar",
  "sgJz4i": "markerade som slutförd",
  "9uiXdI": "Återkopplad",
  "lB/3Ql": "tog bort tilldelning",
  "4J1jCO": "Tilldela",
  "EOSmV3": "ändrade beskrivning",
  "4/kkEE": "Heldag"
}